import { createFileRoute, redirect } from '@tanstack/react-router'
import { createSiteSearch } from 'routes/organization_/site/-searchParams'
import { Route as NewRoute } from 'routes/organization_/site/index'
import { z } from 'zod'

const deprecatedSiteSearchParams = z.object({
  mode: z.enum(['create', 'edit']),
})

export const Route = createFileRoute(
  '/organization_/(deprecated_routes)/$orgID/site'
)({
  validateSearch: deprecatedSiteSearchParams,
  beforeLoad: ({ params, search }) => {
    if (search.mode === 'edit') {
      throw new Error(
        'Edit mode requires site ID. Use /organization/site?mode=edit&orgId={orgId}&siteId={siteId}'
      )
    }

    throw redirect({
      to: NewRoute.to,
      search: createSiteSearch(params.orgID),
      replace: true,
    })
  },
})
